import './_styles.scss';
import React, { StatelessComponent } from 'react';
import {
    ALBUM_LIST_CONTAINER,
    ALBUM_LIST_HEADER,
    ALBUM_LIST_BODY,
    ALBUM_LIST_ITEM,
    BUTTON_NO_TEXT_TRANSFORMATION
} from '../utils/constants';
import { Button } from '../Button';

export interface IAlbumItem {
    phonogramId: number;
    title: string;
    artist: string;
    album: string;
    duration: string;
    url: string;
    volumeIndex?: number;
    songIndex?: number;
}

export interface IAlbumVolume {
    name: string;
    songs: IAlbumItem[];
}

export interface IAlbumListProps {
    headerText: string[];
    volumes: IAlbumVolume[];
    onClick?: (item: IAlbumItem) => void;
    onBlur?: (item: IAlbumItem) => void;
    onFocus?: (item: IAlbumItem) => void;
}

export const AlbumList: StatelessComponent<IAlbumListProps> = props => {
    const { headerText, volumes, onBlur, onClick, onFocus } = props;

    const getColumn = (index: number, columnText: string): React.ReactNode => {
        if (index === 0) {
            return (
                <span>
                    <i className="fa fa-play nonDisplay" aria-hidden="true" />
                    {columnText}
                </span>
            );
        }

        return <span>{columnText}</span>;
    };

    const getList = (songInfo: string[], id: string): React.ReactChild => {
        return (
            <div className="song" id={`song-${id}`}>
                {songInfo.map((columnText, index) => {
                    return <div className="column">{getColumn(index, columnText)}</div>;
                })}
            </div>
        );
    };

    const onClickButton = (song: IAlbumItem): void => {
        if (typeof onClick === 'function') {
            onClick(song);
        }
    };

    const onBlurButton = (song: IAlbumItem): void => {
        if (typeof onBlur === 'function') {
            onBlur(song);
        }
    };

    const onFocusButton = (song: IAlbumItem): void => {
        if (typeof onFocus === 'function') {
            onFocus(song);
        }
    };

    const getHeader = (): React.ReactNode => {
        return (
            <div className={ALBUM_LIST_HEADER}>
                {headerText.map(head => {
                    return <div className="column">{head}</div>;
                })}
            </div>
        );
    };

    const getSongs = (songs: IAlbumItem[], volumeIndex: number): React.ReactElement[] => {
        return songs.map((song, songIndex) => {
            const albumSong: IAlbumItem = {
                phonogramId: song.phonogramId,
                title: song.title,
                artist: song.artist,
                album: song.album,
                duration: song.duration,
                url: song.url,
                volumeIndex,
                songIndex
            };
            return (
                <Button
                    type="button"
                    variant="info"
                    className={`${ALBUM_LIST_ITEM} focusable ${BUTTON_NO_TEXT_TRANSFORMATION}`}
                    onClick={(): void => {
                        onClickButton(albumSong);
                    }}
                    onBlur={(): void => {
                        onBlurButton(albumSong);
                    }}
                    onFocus={(): void => {
                        onFocusButton(albumSong);
                    }}
                >
                    {getList(
                        [`${songIndex + 1}. ${song.title}`, song.artist, song.album, song.duration],
                        song.phonogramId.toString()
                    )}
                </Button>
            );
        });
    };

    const getVolumes = (volum: IAlbumVolume, volumIndex: number): React.ReactElement => {
        if (volum.name !== null) {
            return (
                <div className="volume">
                    <div className="name"> {volum.name} </div>
                    {getHeader()}
                    {getSongs(volum.songs, volumIndex)}
                </div>
            );
        }
        return (
            <div>
                {getHeader()}
                {getSongs(volum.songs, volumIndex)}
            </div>
        );
    };

    return (
        <div className={ALBUM_LIST_CONTAINER}>
            <div className={ALBUM_LIST_BODY}>
                {volumes.map((volume, volumeIndex) => {
                    return getVolumes(volume, volumeIndex);
                })}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/AlbumList/index.tsx